import type { Seo } from "~/modules/api/gql/types/seo";

interface SeoData {
  seo?: Seo;
  title?: string;
  publishedAt?: string;
  modifiedAt?: string;
}

const DEFAULT_IMAGE_URL = "https://content.nurturelife.com/wp-content/uploads/2022/05/image-that-shows-when-site-link-is-shared.png";

export async function setSEO(seoData: SeoData) {
  const { seo } = seoData;
  if (!seo) {
    return;
  }

  useSeoMeta({
    title: () => seoData.title ?? seo?.title,
    description: () => seo?.metaDesc || "",
    ogTitle: () => seo?.opengraphTitle,
    ogDescription: () => seo?.opengraphDescription,
    ogSiteName: () => seo?.opengraphSiteName,
    ogType: () => seo?.opengraphType,
    ogImage: () => seo?.opengraphImage?.sourceUrl ?? DEFAULT_IMAGE_URL,
    twitterCard: "summary_large_image",
    twitterTitle: () => seo?.opengraphTitle,
    twitterImage: () => seo?.opengraphImage?.sourceUrl ?? DEFAULT_IMAGE_URL,
    articleModifiedTime: () => seoData.modifiedAt,
    articlePublishedTime: () => seoData.publishedAt,
  });
}